// extracted by mini-css-extract-plugin
module.exports = {"component":"trip-route-accordion-headline_component__tPgAL"};